import './verticalDivider.scss';

export function VerticalDivider() {
  return <div className="divider-vertical"></div>;
}
